module.exports = __webpack_public_path__ + "img/icon-upload-image.d91887a7.svg";